import { enrollFactor } from '@wix/ambassador-identity-factors-v1-identity-factor/http';
import {
  FactorType,
  EnrollFactorResponse,
} from '@wix/ambassador-identity-factors-v1-identity-factor/types';
import { httpClient } from './httpClient';
import { serializeRegistrationCredential } from '../utils/credentialSerializer';

export class WebAuthnApi {
  public async enrollWebAuthn(
    credential?: Credential,
  ): Promise<EnrollFactorResponse> {
    const serializedCredential = credential
      ? serializeRegistrationCredential(credential as PublicKeyCredential)
      : undefined;

    return httpClient
      .request(
        enrollFactor({
          factorType: FactorType.WEBAUTHN,
          webauthnData: { credential: serializedCredential },
        }),
      )
      .then((response) => response.data);
  }
}
